import React from "react";
import AuthHeroColumn from "./AuthHeroColumn";

const RegisterHeroColumn = (props) => (
  <AuthHeroColumn {...props} variant="register" />
);

export default RegisterHeroColumn;
